module.exports = __webpack_public_path__ + "static/media/Tormund Giantsbane 3.1398df03.jpg";